import SEO from "@/components/SEO";
import { serviceSchema } from "@/lib/structuredData";
import MultiStepQuoteForm from "@/components/sections/MultiStepQuoteForm";
import TrustBadges from "@/components/sections/TrustBadges";
import { ShieldCheck, ClipboardCheck, Banknote, Upload } from "lucide-react";

export default function SellYourCar() {
  return (
    <div data-testid="page-sell">
      <SEO
        title="Sell Your Car — Carfornia Buyers | Request an Offer"
        description="Request a no-obligation offer for your car from Carfornia Buyers in Hayward, CA. We inspect in person, make a written offer and pay the same day if you accept."
        canonical="https://carforniabuyers.com/sell-your-car"
        jsonLd={serviceSchema()}
      />
      <section className="py-12 lg:py-20 bg-gradient-to-b from-blue-50/50 via-white to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <aside className="lg:col-span-4 lg:sticky lg:top-28 space-y-6">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-blue">Sell your car</p>
                <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mt-2">
                  Request your offer in three quick steps.
                </h1>
                <p className="text-slate-600 mt-4 leading-relaxed">
                  This is an offer request, not a purchase offer. We review it, inspect your car in person and then make you a real written offer. No SSN. No credit check. No obligation.
                </p>
              </div>
              <div className="space-y-4">
                {[
                  { Icon: ShieldCheck, t: "No obligation", d: "Submitting the form commits you to nothing." },
                  { Icon: ClipboardCheck, t: "Written offer after inspection", d: "The real offer comes after we see the car." },
                  { Icon: Banknote, t: "Same-day payment", d: "Paid the same day if you accept the offer." },
                  { Icon: Upload, t: "Have another offer?", d: "Upload it in step 2 and we’ll try to beat it." },
                ].map(({ Icon, t, d }) => (
                  <div key={t} className="flex items-start gap-3">
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-blue-50 text-brand-blue flex-shrink-0"><Icon className="w-5 h-5" /></span>
                    <div>
                      <div className="font-semibold text-slate-900">{t}</div>
                      <div className="text-sm text-slate-600">{d}</div>
                    </div>
                  </div>
                ))}
              </div>
            </aside>

            <div className="lg:col-span-8">
              <MultiStepQuoteForm />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-surface">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <TrustBadges />
        </div>
      </section>
    </div>
  );
}
